import { withClientContext } from "~/apollo/client";
import { useGetDdqProdOpsQueueQuery } from "~/graphql/supergraphHooks";
import type { DdqQueueRow } from "./types";
import type { DdqQueueFilterVariables } from "./useDdqQueueFilters";
import type { ApolloError } from "@apollo/client";

export type UseDdqProdOpsQueueResult = {
  rows: DdqQueueRow[];
  totalCount: number;
  isLoading: boolean;
  error?: ApolloError;
  refetch: () => void;
};

export const useDdqProdOpsQueue = (
  filters: DdqQueueFilterVariables,
): UseDdqProdOpsQueueResult => {
  const { data, loading, error, refetch } = useGetDdqProdOpsQueueQuery({
    context: withClientContext("federation"),
    variables: filters,
    fetchPolicy: "cache-and-network",
    // `tasks.assignee` is the only nullable field selected, so it's the only one that can
    // fail without null-propagating the whole response; "none" would discard those rows.
    errorPolicy: "all",
  });

  return {
    rows: data?.ddqProdOpsQueue?.items ?? [],
    totalCount: data?.ddqProdOpsQueue?.totalCount ?? 0,
    isLoading: loading,
    error,
    refetch: () => void refetch(),
  };
};
